import { SET_CAPITALIZATION_OF_EARNINGS } from "./mutations";
import {store} from "../../index";
import CapitalizationOfEarning from "../../../models/valuation/CapitalizationOfEarning";
import {generateForecastFreeCashFlow} from "../forecastFCF/actions";
import {generateCapitalizationRate} from "../capitalizationRate/actions";
import {generateForecastCashToEarnings} from "../forecastCashToEarning/actions";


export const generateCapitalizationOfEarnings = () => (dispatch) => {
  //dispatch(generateForecastFreeCashFlow())
  //dispatch(generateCapitalizationRate())      //these two dispatchs are done in generateForecastCashToEarnings()
  dispatch(generateForecastCashToEarnings())

  const {
    capitalizationOfEarnings,
    forecastFCF,
    capitalizationRate,
    forecastCashToEarning
  } = store.getState()

  const { forecastFreeCashFlow } = forecastFCF

  const relatedValues = {
    afterTaxFreeCashFlow: forecastFreeCashFlow.forecastedFreeCashFlowAfterTax.afterTaxFreeCashFlow,
    afterTaxNetCashFlowCapitalizationRate: capitalizationRate.capitalizationRate.afterTaxCapitalizationRate.afterTaxNetCashFlowCapitalizationRate,
    preTaxFreeCashFlow: forecastCashToEarning.forecastCashToEarnings.preTaxNetIncomeConversionFactor.preTaxFreeCashFlow,
    preTaxNetCashFlowCapitalizationRate: capitalizationRate.capitalizationRate.preTaxCapitalizationRate.preTaxNetCashFlowCapitalizationRate,
    ebit: forecastFreeCashFlow.forecastedFreeCashFlowAfterTax.ebit,
    preTaxNetIncomeCapitalizationRate: forecastCashToEarning.forecastCashToEarnings.cashToEarningsFactor.preTaxNetIncomeCapitalizationRate
  }

  if (capitalizationOfEarnings.capitalizationOfEarnings) {
    dispatch({
      type: SET_CAPITALIZATION_OF_EARNINGS,
      payload: new CapitalizationOfEarning({
        ...capitalizationOfEarnings.capitalizationOfEarnings,
        ...relatedValues
      })
    })

    return
  }

  dispatch({
    type: SET_CAPITALIZATION_OF_EARNINGS,
    payload: new CapitalizationOfEarning({
      ...relatedValues
    })
  })

}